import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import Strategic from '../../../widgets/Strategic/Strategic'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import { getSchemaStrategic } from '../../../redux/actions/strategic'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'

export default function ProposalStrategic() {
  // const [isEditAll, setIsEditAll] = useState(false)
  const [isEditWidget, setIsEditWidget] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [showEditAll, setShowEditAll] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  // const projectId = '0219B95A-097A-444C-B903-7F39EBBBA6EE'

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSchemaStrategic(projectId)
      setSchema(_schema.model)
      setIsEditWidget({
        strategic:
          _schema?.model?.forms?.ProjectStrategy?.optionSelected?.length > 0 ? false : true,
      })
      setShowEditAll(!_schema.forms?.ProjectStrategy?.disabled)
    } catch (e) {
      console.log('e', e)
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      {showEditAll && (
        <BtnEditAll
          onClickEditAll={getIsEditAll(isEditWidget)}
          setOnClickEditAll={(_isEdit) => setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)}
        />
      )}

      <Strategic
        showCommandButton={!schema.forms?.ProjectStrategy.disabled}
        schema={schema.forms?.ProjectStrategy}
        isEdit={isEditWidget.strategic}
        isReview
        onChangeIsEdit={(_isEdit) => handleOnChangeIsEdit('strategic', _isEdit, setIsEditWidget)}
      />
      <br />
    </SidebarProposal>
  )
}
